/*
 * The contact form's price match details (request 166): shown, and required,
 * only while "Price match" is the reason; disabled otherwise, so a message
 * about anything else carries none of the three fields.
 */
(function () {
  var form = document.querySelector('[data-contact-form]');
  if (!form) return;
  var reason = form.querySelector('select[name="contact[Reason]"]');
  var box = form.querySelector('[data-contact-price-match]');
  if (!reason || !box) return;
  var inputs = box.querySelectorAll('input');

  function sync() {
    var on = /price match/i.test(reason.value);
    box.hidden = !on;
    inputs.forEach(function (input) {
      input.required = on;
      input.disabled = !on;
    });
  }

  reason.addEventListener('change', sync);
  sync();
})();
